// Mesures sur une charge base64, pour refuser une fiche trop lourde ou trop longue AVANT l'envoi.
// `pagesPdf` est le jumeau de `compterPagesPdf` (supabase/functions/_shared/media.ts), qui refait le
// contrôle côté serveur : ici, on prévient tôt ; là-bas, on ne consomme rien.

/** Taille décodée d'une chaîne base64. */
export function octetsBase64(b64: string): number {
  const len = b64.replace(/\s/g, '').length;
  if (len === 0) return 0;
  const remplissage = b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0;
  return Math.floor((len * 3) / 4) - remplissage;
}

/** Pages d'un PDF, estimées ; 0 = inconnu (le PDF n'est alors pas refusé ici). */
export function pagesPdf(b64: string): number {
  if (typeof atob !== 'function') return 0;
  let binaire: string;
  try {
    binaire = atob(b64.replace(/\s/g, ''));
  } catch {
    return 0;
  }
  const objets = (binaire.match(/\/Type\s*\/Page(?![A-Za-z])/g) ?? []).length;
  const comptes = [...binaire.matchAll(/\/Type\s*\/Pages\b[^>]*?\/Count\s+(\d+)/g)].map((m) => Number(m[1]));
  return Math.max(objets, ...comptes, 0);
}
